
/*
 * @description: 石化运输-货源信息   数据接口
 * @author: zb
 * @update: zb
 * @Date: 2019-05-27 09:29:57
 * @LastEditors: l_hc
 * @LastEditTime: 2019-07-24 14:24:24
 */
import { Page } from '@/utils/commonDataModel'

import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

const prefix = `${LOGISTICE_GATEWAY}/website/personal/goodsInvitationOffer/cmsGoodsInvitationOffer/goodsInvitationOffer`

/* 保存多条邀请报价数据的地址  */
const saveUrl = `${prefix}`

/* 编辑数据的地址  */

// /* 分页查询货源信息 */
// export const getPageList = (page, params) => {
//   return http.post(findList, undefined, { serialize: false, params: { params: Object.assign({ 'methodName': 'findList' }, params, page || new Page()) }})
// }
/* 保存多条数据 */
export const saveList = (params) => {
  return logistice.post(saveUrl, undefined, { serialize: false, params: { params: Object.assign(params, { 'methodName': 'batchSave' }) }})
}

// 获取货源邀请报价的运力方信息
export const findTransportList = (page, params) => {
  return logistice.post(saveUrl, undefined, { serialize: false, params: { params: Object.assign({ 'methodName': 'findTransportList' }, params, page || new Page()) }})
}

